import CSCPTable from "../cscp-table"

export default class AbstractReport extends CSCPTable {
    constructor() {
        super();
    }

    initSettings() {
        let that = this;

        that.instance = "cscpjs.default.abstractReportjs";
        that.method = "/Reports/AbstractPaging";
        that.tableId = "abstractTable";
        that.searchBtnEleId = "abstractTableSearch";

        that.columns = [
            { customContent: (row) => { return row.FirstName + " " + row.LastName }, class: "column-quarter" },
            { data: "Email", class: "column-quarter" },
            { data: "Institution", class: "column-quarter" },
            {
                customContent: (row) => {
                    return `<a onclick="cscpjs.default.tablesjs.openUrlNewTab('DownloadFiles','FileDownload','?id=${row.ID}&user=${that.additionalAttr.user}&hash=${that.additionalAttr.hash}&returnUrl=${that.additionalAttr.returnUrl}')">
                                ${that.additionalAttr.downloadLabel}
                            </a>`
                }, class: "column-quarter-last"
            }
        ]
        that.filterContainerEleId = "reportFilterForm";
    }
}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/abstractReport.js